import * as d3array from 'd3-array';
import {
  DateRange,
  ComparisonDelta,
  MetricPillValue,
  MetricValueRole,
  DataTable,
  DataRow,
  ValueAccessor,
} from './models';
import { DefaultMeasureAccessor } from './models/Accessor';
import { isNullOrUndefined } from './models/DataTable';

export const getLatestValue = (
  table?: DataTable,
  accessor: ValueAccessor<number | undefined> = DefaultMeasureAccessor
): DataRow | undefined => {
  if (table && table.length) {
    for (let i = table.length - 1; i > -1; i--) {
      const point = table[i];
      const value = accessor(point);
      if (!isNullOrUndefined(value)) {
        return point;
      }
    }
  }
  return undefined;
};

export const mapRolesToValues = (
  roles: ReadonlyArray<MetricValueRole>,
  value: number,
  comparison?: ComparisonDelta
): ReadonlyArray<MetricPillValue> => {
  return roles
    .map((role) => {
      switch (role) {
        case MetricValueRole.CURRENT:
          return { role, value };
        case MetricValueRole.ABSOLUTE_CHANGE:
          return comparison ? { role, value: comparison.absolute } : undefined;
        case MetricValueRole.PERCENTAGE_CHANGE:
          return comparison ? { role, value: comparison.percentage } : undefined;
        default:
          return undefined;
      }
    })
    .filter((element) => element !== undefined) as ReadonlyArray<MetricPillValue>;
};

export const getComparisonDateRange = (data: DataTable): DateRange | undefined => {
  const [first, last] = d3array.extent(data, (p) => p.comparisonTimestamp as Date);
  if (first && last) {
    return { first, last } as DateRange;
  }

  return undefined;
};
